import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Services from '../Pages/ArtprintsViewAll';
import CategoryNavigation from '../Components/CategoryNavigation';

const ArtprintsViewAll = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <div className='mt-20 flex flex-wrap justify-center gap-14 pt-5 pb-8 md:pb-0' id='our'>
        <div className="max-w-4xl mx-auto px-6 py-0 sm:py-0 md:py-8 text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif text-gray-800 mb-2">
            Paintings complete your space with depth, character, and expression.
          </h1>
          <div className="max-w-2xl mx-auto">
            <CategoryNavigation type="artprints" currentLink="/artprints" />
          </div>
        </div>
      </div>
    <Services />
    <div className='pb-10'></div>
    <Footer />
    </div>
  )
}

export default ArtprintsViewAll;